export default "__VITE_ASSET__BoopJQuV__"